<template>
	<div id="headerPagina">
		<div class="barraTopo">
			<div class='flex3cols' style="width:25%;">&nbsp;</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import BaseMixin from './../../mixins/BaseMixin';

export default {
	mixins: [BaseMixin],
	computed:{
		
	},
	methods: {
		...mapActions("authenticationStore", ["logout"]), //transformando a Action em uma "função"

		logout () {
			
			this.$store.dispatch('authenticationStore/logout');
			
        }
	} 
	
	

}
</script>

<style scoped>
	.btnPadraoTopo{
		padding-top: 15px;
	}
</style>